
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visits",
      function () {
        return require("private-next-pages/visits/index.js");
      }
    ]);
  